import { isEmpty } from './object';
const REG_EXP_BOOL = /^(?:true|false)$/i;
const REG_EXP_TRUE = /^true$/i;
export const isBooleany = (value) => REG_EXP_BOOL.test(value);
export const isString = (value) => typeof value === 'string';
export const parseBoolean = (value) => {
    switch (typeof value) {
        case 'function': return parseBoolean(value());
        case 'number': return value > 0;
        case 'object': return Array.isArray(value) ? parseBoolean(value.length) : !isEmpty(value);
        case 'string':
            const num = parseInt(value, 10);
            return isNaN(num) ? REG_EXP_TRUE.test(value) : parseBoolean(num);
        default: return !!value;
    }
};
export const isUndefined = (subject) => typeof subject === 'undefined';
